import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { NavBack } from "./NavBack";
import { NavItem } from "./MenuGridIcon";
import { useAuth } from "@/contexts/AuthContext";
import path from "node:path";
import { ArrowLeft } from "lucide-react";

export function MenuRowIcon({ menus }:{
	menus: NavItem[];
	root?: boolean;
	backpath?: string;
}) {

	const { hasRole } = useAuth()

	function hasRoles(roles: number[]) {
		return roles.some(role => hasRole(role))
	}

	function showMenu() {
		let elements: any[] = []
		let i = 0;
		// if (!root) {
		// 	if (backpath) {
		// 		elements.push(<NavLink key={i} to={backpath} className="flex flex-col items-center justify-center p-2 group">
		// 			<div className="text-blue-500 group-hover:text-blue-600 group-hover:scale-110 mb-3 drop-shadow hover:drop-shadow-xl transform hover:-translate-y-1 transition-all duration-200 ">
		// 				<ArrowLeft size={32} />
		// 			</div>
		// 			<span className="text-xs font-medium text-(--color-secondary) text-center">
		// 				Back
		// 			</span>
		// 		</NavLink>)
		// 	} else {
		// 		const navigate = useNavigate();
		// 		elements.push(<div key={i}
		// 			onClick={() => navigate(-1)} 
		// 			className="text-blue-500 group-hover:text-blue-600 group-hover:scale-110 mb-3 drop-shadow hover:drop-shadow-xl transform hover:-translate-y-1 transition-all duration-200 ">
		// 			<ArrowLeft size={32} />
		// 			<span className="text-xs font-medium text-(--color-secondary) text-center">
		// 				Back
		// 			</span>
		// 		</div>)
		// 	}			
		// }

		for (const item of menus) {
			if (!item.roles || hasRoles(item.roles)) {
				i++;
				elements.push(
					<NavLink key={i} to={item.to} className="flex flex-col items-center justify-center p-2 group">
						<div className="text-blue-500 group-hover:text-blue-600 group-hover:scale-110 mb-3 drop-shadow hover:drop-shadow-xl transform hover:-translate-y-1 transition-all duration-200 ">
							{item.icon}
						</div>
						<span className="text-xs font-medium text-(--color-secondary) text-center">
							{item.label}
						</span>
					</NavLink>
				)
			}
		}
		return <div className="flex gap-1 p-1 min-w-max">
			{ elements }
			</div>
	}

	return (
		<div className="overflow-x-auto scrollbar-none [-ms-overflow-style:none]">
				{ showMenu() }			
		</div>
	)
}